@if (errorMessage(); as message) {
<div class="position-fixed top-0 start-0 w-100 p-5 shadow bg-danger text-white d-flex justify-content-center z-index-3"
    role="alert">
    <div class="container-xl d-flex align-items-center justify-content-between">
        <span>{{ message }}</span>
        <button type="button" class="btn-close btn-close-white" (click)="onClose()" aria-label="Close"></button>
    </div>
</div>
}